import moment from 'moment-timezone';
import { SEARCH_SUCCESS, SEARCH_START } from 'actions/events';
import {
  SET_SHOW_SYSTEM_EVENTS,
  SET_DATE_RANGE,
  SET_SORT,
  SET_SEARCH,
  SET_COLUMN_STATE,
  TOGGLE_COLUMN_VISIBILITY,
  REDIRECT_AUTOMATICALLY_TO_ALL_EVENTS,
  EVENT_SELECTION,
  UNSELECT_ALL,
  SELECT_ALL,
} from '@xmatters/redux/actions/allEvents';

export const getDefaultState = () => ({
  sortBy: 'start_time',
  sortOrder: 'DESCENDING',
  showSystemEvents: false,
  dateRange: { preset: 'PAST_24HOURS', from: null, to: null },
  search: {},
  columnState: [],
  selectedEvents: {},
});

export default function allEvents(state = getDefaultState(), action) {
  switch (action.type) {
    case SEARCH_SUCCESS: {
      const to =
        action.payload.links.self.match(/to=(.+?)&/)?.[1] ?? Date.now();
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        selectedEventsTimestamp: to,
      };
    }
    case SET_SHOW_SYSTEM_EVENTS: {
      return {
        ...state,
        showSystemEvents: action.payload,
      };
    }
    case SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      };
    }
    case SET_SORT: {
      return {
        ...state,
        sortOrder: action.payload.sortOrder,
        sortBy: action.payload.sortBy,
      };
    }
    case SET_SEARCH: {
      return {
        ...state,
        search: action.payload,
      };
    }
    case SET_COLUMN_STATE: {
      return {
        ...state,
        columnState: action.payload,
      };
    }
    case TOGGLE_COLUMN_VISIBILITY: {
      const column = state.columnState.find(
        col => col.colId === action.payload,
      );

      if (column) {
        return {
          ...state,
          columnState: [
            ...state.columnState.filter(col => col.colId !== column.colId),
            { ...column, hide: !column.hide },
          ],
        };
      }
      return { ...state };
    }
    case REDIRECT_AUTOMATICALLY_TO_ALL_EVENTS: {
      const { payload } = action;
      return {
        ...state,
        redirectAutomaticallyToAllEvents: payload,
      };
    }
    case EVENT_SELECTION: {
      return {
        ...state,
        selectedEvents: {
          ...state.selectedEvents,
          [action.payload.eventId]: action.payload.isSelected,
        },
      };
    }
    case SEARCH_START:
    case UNSELECT_ALL: {
      return {
        ...state,
        selectedEvents: {},
      };
    }
    case SELECT_ALL: {
      return {
        ...state,
        selectedEvents: true,
        selectedEventsTimestamp: moment(),
      };
    }
    default:
      return state;
  }
}
